// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Actions
// ----------------------------------------------------------------------------
export const INCREASE = 'INCREASE'
export const DECREASE = 'DECREASE'
export const UPDATE_MEDIA_STATE = 'UPDATE_MEDIA_STATE'
export const UPDATE_SCREEN_SIZE_STATE = 'UPDATE_SCREEN_SIZE_STATE'
export const UPDATE_HEADER_STATE = 'UPDATE_HEADER_STATE'
export const UPDATE_WEBSITE_STATE = 'UPDATE_WEBSITE_STATE'

// Message bus
export const UPDATE_NOTICE_QUEUE = 'UPDATE_NOTICE_QUEUE'
export const PUSH_NOTICE = 'PUSH_NOTICE'
export const POP_NOTICE = 'POP_NOTICE'

// ----------------------------------------------------------------------------
// ------------------------------------------------------------ Action creators
// ----------------------------------------------------------------------------
/** updateNoticeQueue */
export const updateNoticeQueue = (initObject) => ({
  type: UPDATE_NOTICE_QUEUE,
  payload: initObject,
})

/** pushNotice */
export const pushNotice = (initObject) => ({
  type: PUSH_NOTICE,
  payload: initObject,
})

/** popNotice */
export const popNotice = (initObject) => ({
  type: POP_NOTICE,
  payload: initObject,
})

/** Increase */
export const increase = (initObject) => ({
  type: INCREASE,
  payload: initObject,
})

/** Decrease */
export const decrease = (initObject) => ({
  type: DECREASE,
  payload: initObject,
})

/** updateMediaState */
export const updateMediaState = (initObject) => ({
  type: UPDATE_MEDIA_STATE,
  payload: initObject,
})

/** updateScreenSizeState */
export const updateScreenSizeState = (initObject) => ({
  type: UPDATE_SCREEN_SIZE_STATE,
  payload: initObject,
})

/** updateHeaderState */
export const updateHeaderState = (initObject) => ({
  type: UPDATE_HEADER_STATE,
  payload: initObject,
})

/** updateWebsiteState */
export const updateWebsiteState = (initObject) => ({
  type: UPDATE_WEBSITE_STATE,
  payload: initObject,
})
